import React, { useEffect, useState } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ArticleContent } from './components/ArticleContent';
import { Testimonials } from './components/Testimonials';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';

// Final Sticky CTA with AG1-level polish
function StickyCTA({
  visible
}: {
  visible: boolean;
}) {
  return <div className={`fixed bottom-0 left-0 w-full z-50 py-3 flex justify-center transition-opacity duration-700 ease-in-out ${visible ? 'opacity-100' : 'opacity-0 pointer-events-none'} bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]`} data-id="element-0">
      <a href="https://claritysupplement.com/products/clarity-superfood-daily-gummies?selling_plan=3249799266&variant=42047379865698&utm_source=advertorial&utm_medium=stickycta&utm_campaign=clarity_launch" target="_blank" rel="noopener noreferrer" className="bg-[#0A1F44] text-white px-6 py-4 rounded-full font-semibold text-base sm:text-lg shadow hover:bg-[#132a5c] transition-all duration-200 flex items-center gap-2" data-id="element-1">
        <span data-id="element-2">🔒</span>
        <span data-id="element-3">Try Clarity – Only $2.11/day + Free Shipping</span>
      </a>
    </div>;
}
export function App() {
  const [showCTA, setShowCTA] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 900) {
        setShowCTA(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="w-full min-h-screen bg-white font-sans relative" data-id="element-4">
      <Header data-id="element-5" />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8 pb-32" data-id="element-6">
        <HeroSection data-id="element-7" />
        <ArticleContent data-id="element-8" />
        <Testimonials data-id="element-9" />
        <PricingSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
      <StickyCTA visible={showCTA} data-id="element-12" />
    </div>;
}